import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AdminLayout } from '@/components/admin/admin-layout.tsx';
import { AdminProviders } from '@/components/admin/admin-providers.tsx';
import { useAuth } from '@/store/auth.ts';

// Admin-area layout route. The gate runs before any child loads: anonymous →
// /login, STUDENT → /courses (learner area). ADMIN + TEACHER both reach the
// console; platform-admin-only pages are further gated per-route (the adminOnly
// menu filter in AdminLayout hides them for TEACHER, and those child routes
// bounce TEACHER to /admin/courses). AntD providers + the ProLayout shell
// wrap the child Outlet.
export const Route = createFileRoute('/admin')({
  beforeLoad: () => {
    const { user } = useAuth.getState();
    if (!user) throw redirect({ to: '/login' });
    if (user.role === 'STUDENT') throw redirect({ to: '/courses' });
  },
  component: AdminShell,
});

function AdminShell() {
  return (
    <AdminProviders>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </AdminProviders>
  );
}
